import { render, staticRenderFns } from "./ModalTimeline.vue?vue&type=template&id=255adda0&"
import script from "./ModalTimeline.vue?vue&type=script&lang=ts&"
export * from "./ModalTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports